<template>
	<div v-loading="loading">
		<clientModule :moduletitle="name" class="bg divHeight">
			<div class="bg">
				<div class="small-tip">{{ tipText }}</div>
				<div class="list">
					<data-list
						:columns="columns"
						:data="adCampaignVoList"
						:table-style="{ name: 'webclient' }"
					>
					</data-list>
					<data-list
						:columns="adGroupColumns"
						:data="adGroupdata"
						class="adGroup"
						:table-style="{ name: 'webclient' }"
					>
					</data-list>
				</div>
			</div>
		</clientModule>
	</div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import adsPreview from './ads-preview';
export default {
	props: {
		type: {
			type: Number,
		},
		name: { type: String },
	},
	data() {
		return {
			tipType: null,
			isCountry:
				'客户有重点投放国家/地区，因此将创建两个广告系列：“全球”“重点国家”，并为每个推广产品创建一个广告组',
			noCountry:
				'客户没有重点投放国家/地区，将创建一个广告系列；并为每个核心推广产品创建一个广告组',
			columns: [
				{
					label: '广告系列名称',
					bind: 'campainName',
				},
				{
					label: '日预算',
					bind: 'amountMicros',
				},
				{
					label: '定位',
					type: 'custInfo',
					text: [
						{
							bind: 'location',
						},
					],
					formatter(item, row) {
						return row[item.bind] && row[item.bind].length ? row[item.bind].toString() : '-';
					},
				},
				{
					label: '排除',
					type: 'custInfo',
					text: [
						{
							bind: 'exclude',
						},
					],
					formatter(item, row) {
						return row[item.bind] && row[item.bind].length ? row[item.bind].toString() : '-';
					},
				},
				{
					label: '出价策略类型',
					bind: 'biddingStrategyType',
					width: 200,
				},
				{
					label: '投放网络',
					bind: 'advertisingChannelType',
					width: 300,
				},
				{
					label: '语言',
					width: 150,
					type: 'custInfo',
					text: [
						{
							bind: 'languages',
						},
					],
					formatter(item, row) {
						let arr = row[item.bind].map(e => {
							return e.languageNameZh;
						});
						let str = arr.length > 1 ? arr[0] + `等${arr.length}种` : arr[0];
						return str || '-';
					},
				},
				{
					label: '广告组系列设备出价调整',
					bind: 'deviceCriteriaInfoVos',
					width: 180,
					type: 'custInfo',
					isArr: true,
					text: [
						{
							label: '平板电脑',
							bind: 'equipmentBid',
						},
						{
							label: '计算机',
							bind: 'equipmentBid',
						},
						{
							label: '手机',
							bind: 'equipmentBid',
						},
					],
				},
				{
					label: '默认启用状态',
					bind: 'status',
					type: 'mapping',
					parentEvent(type) {
						var name = '-';
						switch (type) {
							case 0:
								name = '关闭';
								break;
							case 1:
								name = '开启';
								break;
							
						}
						return name;
					},
					mapType: 'text',
				},
			],
			adCampaignVoList: [],
			adGroupColumns: [
				{
					label: '广告组名称',
					bind: 'adGroupName',
				},
				{
					label: '所属广告系列',
					bind: 'campaignName',
				},
				{
					label: '出价',
					bind: 'cpcBidMicros',
				},
				{
					label: '广告组设备出价调整',
					bind: 'deviceCriteriaInfoVos',
					width: 180,
					type: 'custInfo',
					isArr: true,
					text: [
						{
							label: '平板电脑',
							bind: 'equipmentBid',
						},
						{
							label: '计算机',
							bind: 'equipmentBid',
						},
						{
							label: '手机',
							bind: 'equipmentBid',
						},
					],
				},
				{
					label: '默认启用状态',
					bind: 'status',
					type: 'mapping',
					parentEvent(type) {
						var name = '-';
						switch (type) {
							case 0:
								name = '关闭';
								break;
							case 1:
								name = '开启';
								break;
							
						}
						return name;
					},
					mapType: 'text',
				},
			],
			adGroupdata: [],
			adCustomerAssetVo: {},
			loading: false,
			butttonloading: true,
		};
	},
	components: { clientModule, adsPreview },
	computed: {
		queryParam() {
			return this.$route.query;
		},
		tipText() {
			if (this.type == 0) {
				return '将为每个核心推广产品创建一个广告系列，每个广告系列下包含一个广告组';
			} else {
				return this.tipType == 2 ? this.isCountry : this.noCountry;
			}
		},
	},
	watch: {
		type: {
			handler(val) {
				this.loading = true;
				this.getData();
			},
			immediate: true,
		},
	},
	methods: {
		async getData() {
			let res = await adsNewOnlineSer.get_ads({
				...this.queryParam,
				type: this.type,
			});

			this.tipType = res.data.type;
			this.loading = false;
			//广告系列
			this.adCampaignVoList = res.data.adCampaignVoList;
			let arr1 = [];
			if (res.data.adGroupVos && res.data.adGroupVos.length) {
				let arr = res.data.adGroupVos.filter(e => {
					return e.parentId;
				});

				arr1 = res.data.adGroupVos.filter(e => {
					return !e.parentId;
				});
				for (let i = 0; i < arr.length; i++) {
					for (let j = i; j < arr1.length; j++) {
						if (arr1[j].id == arr[i].parentId) {
							arr1.splice(j + 1, 0, arr[i]);
						}
					}
				}
			}
			this.adGroupdata = arr1;
			this.adCustomerAssetVo = res.data.adCustomerAssetVo; //预览数据
		},
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.bg {
	background: #ffffff;
}
.small-tip {
	font-size: 14px;
	font-weight: 400;
	color: #999999;
	margin: 30px 0px 20px 30px;
}
.list {
	background: #ffffff;
	padding: 0px 20px;
}
.adGroup {
	margin-top: 20px;
}
.preview {
	background: #ffffff;
	height: auto;
	margin-top: 10px;
}
.bottom {
	text-align: right;
	line-height: 70px;
	margin-top: 20px;
	height: 70px;
	padding-right: 50px;
	background: #ffffff;
	box-shadow: 0px -4px 4px 0px rgba(51, 51, 51, 0.05);
}
</style>
